import { useEffect } from "react"
import { Routers } from "../../../../../../../constant/Routers"
import { backToLogin } from "../../../../../../../utils/backToLogin"
import { UseSchedulesBatchDeleteType } from "../../../../models/batchDelete"
import { SchedulesBatchDeleteDataType } from "../../../../models/batchDelete/data"
import { useVariables } from "../useVariables"

const { SCR920 } = Routers

export const useSchedulesBatchDelete =
  (): UseSchedulesBatchDeleteType<SchedulesBatchDeleteDataType> => {
    const {
      beforeUpload,
      breadcrumbItems,
      bulkCheck,
      bulkDelete,
      bulkDeleteData,
      bulkFileDelete,
      columnErrors,
      columns,
      countRecord,
      dataTemps,
      errorList,
      fileNameList,
      isDisabledSubmit,
      isLoading,
      isLoadingLayout,
      isNotAccessScreen,
      isOpen,
      isOpenDeleted,
      isResetTable,
      isVisibleBtnCancel,
      isVisibleBtnDelete,
      onCancel,
      onCancelDeleted,
      onChange,
      onOpen,
      onOpenDeleted,
      perItem,
      push,
    } = useVariables()

    const bulkDeleteDataConfirm = () => {
      bulkDeleteData()
      push(SCR920)
    }

    const onOpenDeletedOrGoToHome = () => {
      if (dataTemps.length) {
        onOpenDeleted()
      } else {
        push(SCR920)
      }
    }

    useEffect(() => {
      // ユーザーの画面アクセス許可チェックを処理する。
      if (isNotAccessScreen) {
        // 「SCR973_エラー情報の表示画面」に遷移する。
        const { pathname, state } = backToLogin()
        push({ pathname, state })
      } else bulkCheck()
    }, [])

    return {
      beforeUpload,
      breadcrumbItems,
      bulkDelete,
      bulkDeleteDataConfirm,
      bulkFileDelete,
      columnErrors,
      columns,
      countRecord,
      dataTemps,
      errorList,
      fileNameList,
      isDisabledSubmit,
      isLoading,
      isLoadingLayout,
      isOpen,
      isOpenDeleted,
      isResetTable,
      isVisibleBtnCancel,
      isVisibleBtnDelete,
      onCancel,
      onCancelDeleted,
      onChange,
      onOpen,
      onOpenDeletedOrGoToHome,
      perItem,
    }
  }
